export const collectionPage = {
    'collection.page.title': '{collectionName} | 玩具收藏 | R.Toys',
    'collection.page.description': '探索 “{collectionName}” 系列，其中包括独特的 NFT 和实体玩具。这个主题玩具系列专为真正的行家设计。',
}
